import PropTypes from 'prop-types';

import CaptionGroup from '../Wrappers/CaptionGroup';

import styles from './index.styl';


const SPACING = 8;


export default function LegalInfo({ blocks }) {
  const columnsLength = blocks?.filter(item => !!item[0]).length;

  return (
    <div className={styles.legal}>
      <style jsx>{`
        .${styles.legal}
          margin 0 -${SPACING}px 40px

          :global(.mobile) &
            margin 0
      `}</style>
      {blocks.map(([title, text], index) => {
        if (!title && !text) return null;

        return (
          <CaptionGroup
            columns={columnsLength}
            spacing={SPACING}
            key={index}
            title={title}
            content={text}
          />
        );
      })}
    </div>
  );
}

LegalInfo.propTypes = {
  blocks: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.string)
  ),
};
